import React from "react";
// import { useTranslation } from 'react-i18next';
// core components
import Navbar from "./Navbar.js";
import Footer from "./Footer.js";

import '../../assets/css/Board.css'

export default function PersonalInfoGuide() {
  // const { t } = useTranslation();
  return (
    <>
    <Navbar />
    <div id="Contact" className="register-page">
      <div className="Section">
        <div className="cardWithTitle">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">Privacy Policy</div>
              <div className="SectionHeaderTitle">개인정보처리방침</div>
              <div className="SectionHeaderDescription" style={{fontSize:'16px',backgroundColor:'#eee',padding:'10px 20px'}}>
              주식회사 인투스페이스('http://www.intospace.co.kr', 이하 ㈜인투스페이스)는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고
              개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
              <br/>
              ㈜인투스페이스는 개인정보처리방침을 개정하는 경우
              웹사이트 게시 또는 개별공지를 통하여 공지할 것입니다.
              <br/>
              <br/>
              <b>○ 본 방침은 2023년 9월 1일부터 시행됩니다.</b>
              </div>
            </div>
          </div>

          <div className="SectionContents" style={{marginTop:'30px', textAlign:'left'}}>
          <ol>  
            <li className="txt-title">1. 개인정보의 처리 목적</li>
                <br/>
                <span>(주)인투스페이스는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</span>

                <ul className="title">
                  <li>ㅁ 홈페이지 회원가입 및 관리</li>
                  <ul>
                    <li>
                    - 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증 등을 목적으로 개인정보를 처리합니다.
                    </li>
                  </ul>
                </ul>

            <li className="txt-title">2. 개인정보의 처리 및 보유 기간</li>

                <ul>
                  <li>(주)인투스페이스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유, 이용기간 내에서 개인정보를 처리, 보유합니다.
                각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</li>
                </ul>
                <ul className="title">
                  <li>ㅁ 홈페이지 회원가입 및 관리</li>
                  <ul>
                    <li>
                    '홈페이지 회원가입 및 관리'와 관련한 개인정보는 수집.이용에 관한 동의일로부터 '사업자, 단체의 회원 탈퇴 시'까지 아래의 이용목적을 위하여만 보유, 이용됩니다.
                    </li>
                    <li>
                    - 보유근거 : 홈페이지 회원 신원확인용
                    </li>
                  </ul>
                </ul>

            <li className="txt-title">3. 개인정보 수집 항목</li>
                <ul>
                  <li>ㅁ 개인정보 항목 : 이메일(로그인ID), 비밀번호, 이름, 휴대전화번호(선택입력사항)</li>
                  <li>ㅁ 수집방법 : 홈페이지 회원가입</li>
                  <li>ㅁ 보유근거 : 홈페이지 회원 신원확인용</li>
                  <li>ㅁ 보유기간 : 회원 탈퇴 시</li>
                </ul>
            
            <li className="txt-title">4. 개인정보의 파기</li>
                <ul>
                  <li>㈜인투스페이스는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</li>
                </ul>
                <ul className="title">
                  <li>ㅁ 파기절차</li>
                  <ul>
                    <li>
                    - 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                    </li>
                  </ul>
                  <li>ㅁ 파기기한</li>
                  <ul>
                    <li>
                    - 이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                    </li>
                  </ul>
                  <li>ㅁ 파기방법</li>
                  <ul>
                    <li>
                    - 전자적 파일 형태의 정보를 복원 불가능하도록 완전 삭제, 파기 조치 합니다.
                    </li>
                  </ul>
                </ul>
            
              <li className="txt-title">5. 개인정보 보호책임자</li>

                <ul>
                  <li>㈜인투스페이스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</li>
                </ul>
                <ul className="title">
                  <li>ㅁ 개인정보 보호책임자</li>
                  <ul>
                    <li>
                    - 성명 : 남기욱, 윤상은
                    </li>
                    <li>
                    - 직책 : 대표
                    </li>
                    <li>
                    - 연락처 : 042-870-3502, info@intospace.co.kr
                    </li>
                  </ul>
                </ul>

                <ul className="title">
                  <li>정보주체께서는 ㈜인투스페이스의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. ㈜인투스페이스는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</li>
                </ul>

              <li className="txt-title">6. 개인정보 처리방침 변경</li>

                <ul>
                  <li>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 고지할 것입니다.</li>
                </ul>
            
              <li className="txt-title">7. 개인정보의 안전성 확보 조치</li>

                <ul>
                  <li>(주)인투스페이스는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</li>
                </ul>
                <ul className="title">
                  <li>ㅁ 해킹 등에 대비한 기술적 대책</li>
                  <ul>
                    <li>
                    - ㈜인투스페이스는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
                    </li>
                  </ul>
                  <li>ㅁ 개인정보의 암호화</li>
                  <ul>
                    <li>
                    - 이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
                    </li>
                  </ul>
                  <li>ㅁ 개인정보에 대한 접근 제한</li>
                  <ul>
                    <li>
                    - 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
                    </li>
                  </ul>
                </ul>

            <li className="txt-title">8. 정보주체와 법정대리인의 권리·의무 및 그 행사방법 이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</li>
            
                <ul>
                  <li>정보주체는 ㈜인투스페이스에 대해 언제든지 개인정보 열람,정정,삭제,처리정지 요구 등의 권리를 행사할 수 있습니다.</li>
                </ul>
                <ul className="title">
                  <ul>
                    <li>
                    - 제1항에 따른 권리 행사는 ㈜인투스페이스에 대해 개인정보 보호법 시행령 제41조제1항에 따라 서면, 전자우편, FAX 등을 통하여 하실 수 있으며 ㈜인투스페이스은는 이에 대해 지체 없이 조치하겠습니다.
                    </li>
                  </ul>
                  <ul>
                    <li>
                    - 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                    </li>
                  </ul>
                  <ul>
                    <li>
                    - 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
                    </li>
                  </ul>
                  <ul>
                    <li>
                    - 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
                    </li>
                  </ul>
                  <ul>
                    <li>
                    - ㈜인투스페이스는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
                    </li>
                  </ul>
                </ul>

            
            
            
            
            

          </ol>

          </div>
        </div>

      </div>
    </div>
    <Footer />
    </>
  );
}